import Validation from "./validation";
import NAMES from "./names";

export { NAMES };
export default Validation;
